import { useState, useEffect } from 'react';
import Input, { InputTypes, MLPVersion } from '../Form/Input/Input';
import { DynamicObjectInterface } from '../TableWithAction/TableWithAction';
import { SearchProp } from './types/propsTypes';

const SearchBar = ({
  placeholder,
  onSearch,
  handleReset,
  initialSearchText = '',
  ...props
}: SearchProp & { useDebounce?: boolean }) => {

  const [searchValue, setSearchValue] = useState(initialSearchText);

  useEffect(() => {
    setSearchValue(initialSearchText);
  }, [initialSearchText]);

  const handleKeyDown = (event: DynamicObjectInterface) => {
    if (event.key === 'Enter' || event.key === 13) {
      onSearch(event.target.value);
    }
  };

  const handleOnChange = (event: DynamicObjectInterface) => {
    setSearchValue(event.target.value);
    if (!event.target.value) {
      handleReset();
    }
  };

  const handleSearchIconClick = () => {
    onSearch(searchValue);
  };

  return (
    <Input
      type={InputTypes.SEARCH}
      name={'search'}
      inputIcon={{ iconName: 'search' }}
      mlpVersion={MLPVersion.ONE}
      placeholder={placeholder || 'Search'}
      dashboard={true}
      value={searchValue}
      onKeyDown={handleKeyDown}
      onChange={handleOnChange}
      inputIconOnClick={handleSearchIconClick}
      {...props}
    />
  );
};

export default SearchBar;
